<div id="{{ element.id }}" [attr.data-e2e]="'html-v2-' + element.id">
  <surveys-element-html [element]="htmlElement"></surveys-element-html>
</div>
